import { useSearchParams } from "react-router-dom";
import {
  MdArrowBack,
  MdCreditCard,
  MdCheckCircle,
  MdError,
} from "react-icons/md";
import { useTheme } from "../../common/hooks/useTheme";
import { EmptyState } from "../../common/components/emptyState/EmptyState";
import { YooKassaPaymentStage } from "../../common/components/cartModal/components/yooKassaPaymentStage/YooKassaPaymentStage";
import styles from "./PaymentScreen.module.scss";
import Loader from "../../common/components/loader/Loader";
import { usePaymentScreen } from "./usePaymentScreen";
import { PageMeta } from "../../common/components/pageMeta/PageMeta";

export default function PaymentScreen() {
  const { theme } = useTheme();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const orderId = searchParams.get("orderId");
  const amount = searchParams.get("amount");

  const { error, showResult, handleSuccess, handleError, handleBack } =
    usePaymentScreen({ token, orderId });

  if (!token) {
    return (
      <div
        className={styles.container}
        style={{ backgroundColor: theme.background }}
      >
        <PageMeta />
        <div
          className={styles.header}
          style={{ borderBottomColor: theme.border }}
        >
          <button className={styles.backButton} onClick={handleBack}>
            <MdArrowBack size={24} color={theme.text} />
          </button>
          <h1 className={styles.title} style={{ color: theme.text }}>
            Ошибка
          </h1>
        </div>
        <div className={styles.content}>
          <EmptyState
            icon={MdCreditCard}
            title="Недействительная ссылка"
            description="Ссылка для оплаты устарела или повреждена"
          />
        </div>
      </div>
    );
  }

  if (showResult) {
    return (
      <div
        className={styles.container}
        style={{ backgroundColor: theme.background }}
      >
        <PageMeta />
        <div
          className={styles.header}
          style={{ borderBottomColor: theme.border }}
        >
          <button className={styles.backButton} onClick={handleBack}>
            <MdArrowBack size={24} color={theme.text} />
          </button>
          <h1 className={styles.title} style={{ color: theme.text }}>
            Оплата заказа
          </h1>
        </div>
        <div className={styles.content}>
          <div className={styles.resultContainer}>
            <div
              className={styles.successIcon}
              style={{ backgroundColor: theme.success }}
            >
              <MdCheckCircle size={48} color="#fff" />
            </div>
            <h2 className={styles.resultTitle} style={{ color: theme.text }}>
              Оплата прошла успешно!
            </h2>
            <p
              className={styles.resultDescription}
              style={{ color: theme.textSecondary }}
            >
              Заказ №{orderId} оплачен. Вы можете вернуться в приложение.
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        className={styles.container}
        style={{ backgroundColor: theme.background }}
      >
        <PageMeta />
        <div
          className={styles.header}
          style={{ borderBottomColor: theme.border }}
        >
          <button className={styles.backButton} onClick={handleBack}>
            <MdArrowBack size={24} color={theme.text} />
          </button>
          <h1 className={styles.title} style={{ color: theme.text }}>
            Ошибка
          </h1>
        </div>
        <div className={styles.content}>
          <div className={styles.resultContainer}>
            <div
              className={styles.errorIcon}
              style={{ backgroundColor: theme.danger }}
            >
              <MdError size={48} color="#fff" />
            </div>
            <h2 className={styles.resultTitle} style={{ color: theme.text }}>
              {error}
            </h2>
            <button
              className={styles.retryButton}
              style={{
                backgroundColor: theme.primary,
                color: "#fff",
              }}
              onClick={handleBack}
            >
              Вернуться назад
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={styles.container}
      style={{ backgroundColor: theme.background }}
    >
      <PageMeta />
      <div
        className={styles.header}
        style={{ borderBottomColor: theme.border }}
      >
        <button className={styles.backButton} onClick={handleBack}>
          <MdArrowBack size={24} color={theme.text} />
        </button>
        <h1 className={styles.title} style={{ color: theme.text }}>
          Оплата заказа
        </h1>
      </div>

      <div className={styles.content}>
        {amount && (
          <div className={styles.orderInfo}>
            <p
              className={styles.orderNumber}
              style={{ color: theme.textSecondary }}
            >
              Заказ №{orderId}
            </p>
            <p className={styles.orderAmount} style={{ color: theme.text }}>
              {Number(amount).toLocaleString("ru-RU")} ₽
            </p>
          </div>
        )}

        <div className={styles.widgetContainer}>
          <YooKassaPaymentStage
            token={token}
            paymentId="" // TODO: получить paymentId
            onSuccess={handleSuccess}
            onError={handleError}
            onBack={handleBack}
          />
        </div>
      </div>
    </div>
  );
}
